// internal-deps
import { VALID_PAYMENT_GROUP_TYPES, VALID_PAYMENT_METHODS } from "@swiggy-private/payment-core";
import {
    CodPaymentMethodData,
    ICodPaymentGroup,
    PaymentGroupDataDef,
    PaymentMethodDef,
} from "@swiggy-private/payment-ui";
import { Option, Some, None } from "@swiggy-private/js-fp";

// interfaces
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";
import { COD_PAYMENT_METHOD } from "@payment-client/components/autopay-payment-failure-screen/constants";

export function isCODGroup(group: PaymentGroupDataDef): group is ICodPaymentGroup["paymentData"] {
    return group.groupName.toUpperCase() === VALID_PAYMENT_GROUP_TYPES.COD;
}

export const isCODPaymentMethod = (method: PaymentMethodDef): method is CodPaymentMethodData => {
    return VALID_PAYMENT_METHODS.COD === method.name.toUpperCase();
};

export function getCODPaymentMethod(
    paymentGroups: GetPaymentMethodsResponse["paymentGroup"],
): Option<CodPaymentMethodData> {
    const CODPaymentGroup = paymentGroups.find((group) => isCODGroup(group));

    if (CODPaymentGroup == null) {
        return None;
    }
    return Some(CODPaymentGroup?.paymentMethods?.find(paymentMethod => isCODPaymentMethod(paymentMethod)));
}

export function getCODPaymentMethodForAutoPay(
    paymentGroups?: GetPaymentMethodsResponse["paymentGroup"],
): CodPaymentMethodData {
    return getCODPaymentMethod(paymentGroups || []).unwrapOr(COD_PAYMENT_METHOD);
}
